import React, { FC, Fragment, useEffect, useState } from "react";
import result3 from "../assets/diploma-contract-svgrepo-com (1).svg"
import { BsPatchQuestionFill } from "react-icons/bs";
import { Link, useLocation } from "react-router-dom";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import { baseServiceUrl, sidebarDetails, urls } from "../environment";
import { List } from "@mui/material";

import ListSubheader from "@mui/material/ListSubheader";
import Collapse from "@mui/material/Collapse";
import InboxIcon from "@mui/icons-material/MoveToInbox";
import DraftsIcon from "@mui/icons-material/Drafts";
import SendIcon from "@mui/icons-material/Send";
import ExpandLess from "@mui/icons-material/ExpandLess";
import ExpandMore from "@mui/icons-material/ExpandMore";
import StarBorder from "@mui/icons-material/StarBorder";
import axios from "axios";
import toast from "react-hot-toast";

import WithOutFormAutoComplete from "./WithoutControlAutoComplete";
import useUserStore from "../stores/useUserStores";

// import WithOutFormAutoComplete from "./AutoCompleteMain/WithoutFormAutoComplete";
// import { useUserContext } from "../context/UserContext";
// import { useExamsContext } from "../context/examsContext";

type SidebarProps = {
  side: any;
  handleside: any;
};
const Sidebar: FC<SidebarProps> = ({ side, handleside }): JSX.Element => {
  const location = useLocation();

  //   const userContext = useUserContext();
  //   const examsContext = useExamsContext();
  //   useEffect(() => {
  //     if (userContext && userContext.token) {
  //       examsContext.getViewExamsAction({
  //         page_size: null,
  //         page_index: null,
  //         search_string: null,
  //         isDefault: true
  //       });
  //     }
  //   }, [userContext?.token]);

  // useEffect(() => {
  //   if (examGroupOptions && examGroupOptions.length > 0) {
  //     const selectedVal = examGroupOptions?.[0]?.id || null;
  //     console.log("selected Val >>>>>> ", selectedVal);

  //     userDetails.setSelectedExamGroup(selectedVal);
  //     if (!selectedVal) return;
  //     (async () => {
  //       try {
  //         const response = await axios.post(
  //           baseServiceUrl + urls.candidateExamConducted,
  //           {
  //             exam_group: selectedVal,
  //           },
  //           {
  //             headers: {
  //               Authorization: "Bearer " + userDetails.token,
  //             },
  //           }
  //         );
  //         userDetails.setResultOfExamPapers(response.data);

  //         userDetails.setExamResultDetails(response.data);
  //         if (response?.data && response?.data?.exam_list) {
  //           const _updatedSidebarListing = sidebarDetails.map((self) => {
  //             const _nestedMenu: Array<any> = [];
  //             if (self?.type && self?.type === "result") {
  //               if (Array.isArray(response?.data?.exam_list)) {
  //                 response.data.exam_list.map(
  //                   (selfItem: any, pIndex: number) => {
  //                     _nestedMenu.push({
  //                       sideBarurl: result3,
  //                       sidebarText: `Paper ${pIndex + 1}`,
  //                       navURL: `/dashboard/examinee-portal/examinee-result/${selfItem.exam_id}`,
  //                     });
  //                   }
  //                 );
  //                 return {
  //                   ...self,
  //                   nestedMenu: _nestedMenu,
  //                 };
  //               }
  //             }
  //             return self;
  //           });
  //           setUpdatedSidebarListing(_updatedSidebarListing);
  //         }
  //       } catch (error) {
  //         console.log("error ><<<<<<<<<<<<< ", error);
  //       }
  //     })();
  //   }
  // }, [examGroupOptions]);

  return (
    <Fragment>
      <aside
        id="default-sidebar"
        className={` lg:pt-[80px]   lg:fixed top-0 left-0 h-screen bg-white z-[10]  lg:w-[280px]    transition-transform -translate-x-full  lg:translate-x-0  shadow-2xl lg:flex w-0  ${
          side
            ? "max-lg:absolute   left-[0rem] top-0 bottom-0  duration-300 transition-transform translate-x-[0]  z-20 rounded-md   sm:w-[222px] "
            : " "
        }`}
        aria-label="Sidebar"
      >
        <div className=" h-full  overflow-y-auto bg-gray-50   w-full px-1  ">
          <ul className="space-y-2 font-medium lg:mt-2 ">
            {sidebarDetails?.map((rest, index) => (
              <li key={index}>
                <Link
                  to={Array.isArray(rest.navURL) ? rest.navURL[0] : rest.navURL}
                  onClick={handleside}
                  className={`flex items-center ${
                    Array.isArray(rest.navURL) &&
                    rest.navURL.includes(location.pathname)
                      ? "bg-gray-300"
                      : location.pathname === rest.navURL
                      ? "bg-gray-300"
                      : rest.nestedMenu.find(
                          (self: any) => self.navURL === location.pathname
                        )
                      ? "bg-gray-200"
                      : ""
                  }  p-2 text-gray-900 rounded-lg hover:bg-gray-200  group`}
                >
                  <img src={rest.sideBarurl} className="w-6 h-6" />
                  <span className="flex-1 ms-3 whitespace-nowrap">
                    {rest.sidebarText}
                  </span>
                </Link>
                {rest.nestedMenu.length ? (
                  <>
                    <ul className="ml-4 mt-2">
                      {rest.nestedMenu.map((self: any, _index: number) => (
                        <li key={_index}>
                          <Link
                            to={self.navURL}
                            onClick={handleside}
                            className={`flex items-center ${
                              location.pathname === self.navURL ||
                              (self?.adjacentLink &&
                                self.adjacentLink.includes(location.pathname))
                                ? "bg-gray-300"
                                : ""
                            }  p-2 text-gray-900 rounded-lg hover:bg-gray-200  group`}
                          >
                            <img src={self.sideBarurl} className="w-6 h-6" />
                            <span className="flex-1 ms-3 whitespace-nowrap">
                              {self.sidebarText}
                            </span>
                          </Link>
                        </li>
                      ))}
                    </ul>
                  </>
                ) : (
                  <></>
                )}
              </li>
            ))}

            {/* <li>
              <Link
                to="/admin-dashboard/test-list"
                onClick={handleside}
                className={`flex items-center ${
                  location.pathname === "/admin-dashboard/test-list" ||
                  location.pathname === "/admin-dashboard/create-test"
                    ? "bg-gray-300"
                    : ""
                }  p-2 text-gray-900 rounded-lg hover:bg-gray-200  group`}
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  strokeWidth="1.5"
                  stroke="currentColor"
                  className="w-6 h-6"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    d="M8 10h.01M12 10h.01M16 10h.01M8 14h.01M12 14h.01M16 14h.01M9 16h.01M12 16h.01M15 16h.01M6 10V5a1 1 0 011-1h10a1 1 0 011 1v5M4 15.25a7.75 7.75 0 1115.5 0v.25a3.75 3.75 0 01-7.5 0v-.25"
                  />
                </svg>
                <span className="flex-1 ms-3 whitespace-nowrap">
                  Manage Test
                </span>
              </Link>
            </li>

            <li>
              <Link
                to="/admin-dashboard/result"
                onClick={handleside}
                className={`flex items-center ${
                  location.pathname === "/admin-dashboard/result" ||
                  location.pathname === "/admin-dashboard/result"
                    ? "bg-gray-300"
                    : ""
                }  p-2 text-gray-900 rounded-lg hover:bg-gray-200  group`}
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  strokeWidth="1.5"
                  stroke="currentColor"
                  className="w-6 h-6"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    d="M4.26 10.147a60.438 60.438 0 0 0-.491 6.347A48.62 48.62 0 0 1 12 20.904a48.62 48.62 0 0 1 8.232-4.41 60.46 60.46 0 0 0-.491-6.347m-15.482 0a50.636 50.636 0 0 0-2.658-.813A59.906 59.906 0 0 1 12 3.493a59.903 59.903 0 0 1 10.399 5.84c-.896.248-1.783.52-2.658.814m-15.482 0A50.717 50.717 0 0 1 12 13.489a50.702 50.702 0 0 1 7.74-3.342M6.75 15a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5Zm0 0v-3.675A55.378 55.378 0 0 1 12 8.443m-7.007 11.55A5.981 5.981 0 0 0 6.75 15.75v-1.5"
                  />
                </svg>

                <span className="flex-1 ms-3 whitespace-nowrap">Result</span>
              </Link>
            </li> */}
          </ul>
        </div>
      </aside>
    </Fragment>
  );
};

export default Sidebar;
